<template>
  <button
    :type="type"
    class="btn agent-button"
    :class="['is-' + variant, 'is-' + size, { 'is-loading': loading }]"
    :disabled="disabled || loading"
    @click="$emit('click', $event)"
  >
    <i v-if="loading" class="fa fa-spinner fa-spin"></i>
    <i v-else-if="icon" :class="icon"></i>
    <span v-if="$slots.default" class="agent-button-label"><slot></slot></span>
  </button>
</template>

<script>
export default {
  name: "AgentButton",
  props: {
    variant: {
      type: String,
      default: "primary"
    },
    size: {
      type: String,
      default: "md"
    },
    icon: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: "button"
    }
  }
};
</script>

<style scoped>
.agent-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  border: 1px solid transparent;
  border-radius: 8px;
  font-weight: 800;
  line-height: 1.2;
  white-space: nowrap;
  transition: background-color .18s ease, border-color .18s ease, color .18s ease, box-shadow .18s ease;
}
.agent-button.is-sm {
  min-height: 32px;
  padding: 6px 11px;
  font-size: 12px;
}
.agent-button.is-md {
  min-height: 38px;
  padding: 8px 14px;
  font-size: 12px;
}
.agent-button.is-primary {
  border-color: #fe9b44;
  background: #fe9b44;
  color: #fff;
}
.agent-button.is-primary:hover,
.agent-button.is-primary:focus {
  border-color: #e77f25;
  background: #e77f25;
  color: #fff;
}
.agent-button.is-secondary {
  border-color: #d0d5dd;
  background: #fff;
  color: #344054;
}
.agent-button.is-secondary:hover,
.agent-button.is-secondary:focus {
  border-color: #fe9b44;
  background: #fff8f1;
  color: #b05f18;
}
.agent-button:focus {
  outline: 0;
  box-shadow: 0 0 0 3px rgba(254, 155, 68, .18);
}
.agent-button:disabled {
  cursor: not-allowed;
  opacity: .62;
  box-shadow: none;
}
.agent-button-label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
</style>



// WEBPACK FOOTER //
// src/views/ai/agentV2/components/AgentButton.vue